'use client'

import { PropsWithChildren, useEffect, useRef, useState } from 'react'

import styles from './FadeInSection.module.css'

interface FadeInSectionProps extends PropsWithChildren {
  disableMotion?: boolean
  delayLong?: boolean
}

export default function FadeInSection({ children, disableMotion, delayLong = false }: FadeInSectionProps) {
  const ref = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (disableMotion) {
      setVisible(true)
      return
    }
    const node = ref.current
    if (!node) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          io.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    io.observe(node)
    return () => io.disconnect()
  }, [disableMotion])

  const className = [
    disableMotion ? '' : styles.fade,
    delayLong ? styles.delayLong : styles.delayShort,
    visible ? styles.visible : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
}
